
export default {
  auth: false,
  layout: 'login',
  head () {
    return {
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex, nofollow' },
        { hid: 'referrer', name: 'referrer', content: 'no-referrer' }
      ]
    }
  },
  data () {
    return {
      backendErrors: {},
      success: false,
      errorMessage: false,
      data: {
        email: '',
      },
    }
  },
  methods: {
    async reset () {
      this.backendErrors = {}
      try {
        const response = await this.$axios.post('/api/users/password-reset-request', this.data)

        if (response.data.status === 'success') {
          this.success = true
        } else if (response.data.status === 'error') {
          this.errorMessage = response.data.message
        }

      } catch (e) {
        this.$sentry.captureException(e)

        if (e.response && e.response.status === 422) {
          if (e.response.data.errors) {
            this.backendErrors = e.response.data.errors
          } else {
            this.backendErrors = { message: [e.response.data.message] }
          }
        } else {
          this.$sentry.captureException(e)

          this.$buefy.toast.open({
            message: this.$t('something_wrong'),
            type: 'is-danger'
          })
        }
      }
    }
  }
}
